/* eslint-disable @typescript-eslint/naming-convention */
export const APP_ACCESS_MATRIX: { [action: string]: string[] } = {
    // dashboard
    'dashboard.view': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_MACHINES_CLAIM,
        import.meta.env.VITE_MSAL_READ_IMPLEMENTS_CLAIM,
        import.meta.env.VITE_MSAL_READ_COMPATIBILITY_CLAIM,
    ],
    // machines
    'machines.read': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_MACHINES_CLAIM,
    ],
    'machines.write': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_MACHINES_CLAIM],
    'machines.view': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_MACHINES_CLAIM,
        import.meta.env.VITE_MSAL_WRITE_MACHINES_CLAIM,
    ],
    'machines.create': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_MACHINES_CLAIM],
    'machines.update': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_MACHINES_CLAIM],
    'machines.delete': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_MACHINES_CLAIM],
    // implements
    'implements.read': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_IMPLEMENTS_CLAIM,
    ],
    'implements.write': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_IMPLEMENTS_CLAIM],
    'implements.view': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_IMPLEMENTS_CLAIM,
        import.meta.env.VITE_MSAL_WRITE_IMPLEMENTS_CLAIM,
    ],
    'implements.create': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_IMPLEMENTS_CLAIM],
    'implements.update': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_IMPLEMENTS_CLAIM],
    'implements.delete': [import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME, import.meta.env.VITE_MSAL_WRITE_IMPLEMENTS_CLAIM],
    // compatibility
    'compatibility.read': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_COMPATIBILITY_CLAIM,
    ],
    'compatibility.write': [
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_WRITE_COMPATIBILITY_CLAIM,
    ],
    'compatibility.export': [
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_WRITE_COMPATIBILITY_CLAIM,
    ],
    'compatibility.view': [
        import.meta.env.VITE_MSAL_READER_ROLE_NAME,
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_READ_COMPATIBILITY_CLAIM,
        import.meta.env.VITE_MSAL_WRITE_COMPATIBILITY_CLAIM,
    ],
    'compatibility.create': [
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_WRITE_COMPATIBILITY_CLAIM,
    ],
    'compatibility.update': [
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_WRITE_COMPATIBILITY_CLAIM,
    ],
    'compatibility.delete': [
        import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
        import.meta.env.VITE_MSAL_WRITE_COMPATIBILITY_CLAIM,
    ],
    'agent.read': [import.meta.env.VITE_MSAL_AGENT_ROLE_NAME],
    // bulk-update
    // 'bulk_update.read': [
    //     import.meta.env.VITE_MSAL_READER_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_READ_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.write': [
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.view': [
    //     import.meta.env.VITE_MSAL_READER_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_READ_BULK_UPDATE_CLAIM,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.export': [
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_READ_BULK_UPDATE_CLAIM,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.import': [
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_READ_BULK_UPDATE_CLAIM,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.create': [
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.update': [
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // 'bulk_update.delete': [
    //     import.meta.env.VITE_MSAL_ADMIN_ROLE_NAME,
    //     import.meta.env.VITE_MSAL_WRITE_BULK_UPDATE_CLAIM,
    // ],
    // translations
};
